const $ = window.jQuery;

window.jQuery(() => {
	//using a delegated event allows this to work even in a modal whose contents are loaded after page load (e.g. ajax)
	window.jQuery(document).on('change', '.related-country', handleCountryChange);
});

const handleCountryChange = async (e) => {
	// console.log('detected country change');
	const $this = window.jQuery(e.target);
	const group = $this.data('group');
	const $selected = $this.find('option:selected');
	const newCountryCode = $selected.val();
	const newPostalRegex = $selected.data('postalregex');

	let newSubdivisionLabel = $selected.data('subdivisionlabel');
	if (newSubdivisionLabel == '') {
		newSubdivisionLabel = 'State/Province';
	}

	window.jQuery(`.related-postalCode[data-group=${group}]`).attr('pattern', newPostalRegex);
	window.jQuery(`.related-subdivision-label[data-group=${group}]`).html(newSubdivisionLabel);

	const $wrapper = window.jQuery(`.related-subdivision[data-group=${group}]`);
	const $currentSub = $wrapper.find('select,input');
	const currentSubName = $currentSub.attr('name');
	const currentSubId = $currentSub.attr('id');
	const currentSubClass = $currentSub.attr('class');
	const currentSubStyle = $currentSub.attr('style');
	const includeBlankOption =
		$currentSub.is('select') && $currentSub.find('option[value=""]').length > 0;

	if (!newCountryCode) {
		$wrapper
			.empty()
			.html(
				`<input type="text" name="${currentSubName}" id="${currentSubId}" class="${currentSubClass}" style="${currentSubStyle}" value="">`
			);
		return;
	}

	const subdivisions = await getSubdivisions(newCountryCode);

	if (subdivisions.length === 0) {
		$wrapper
			.empty()
			.html(
				`<input type="text" name="${currentSubName}" id="${currentSubId}" class="${currentSubClass}" style="${currentSubStyle}" value="">`
			);
	} else {
		$wrapper
			.empty()
			.html(
				[
					`<select name="${currentSubName}" id="${currentSubId}" class="${currentSubClass}" style="${currentSubStyle}">`,
					includeBlankOption ? '<option value="">~ please select ~</option>' : '',
					subdivisions.map((sp) => `<option value="${sp.code}">${sp.name}</option>`).join(''),
					'</select>'
				].join('')
			);
	}
};

const getSubdivisions = async (countryCode) => {
	const raw = await fetch(`/index.cfm/isodata/getSubdivisions?country=${countryCode}`);
	return await raw.json();
};
